import React from 'react';
import { Link } from 'react-router-dom';
import * as PropTypes from 'prop-types';
import { VideoItemAdditionalMetadata } from './video-item-additional-metadata';
import { DurationMask } from 'components/video-item/masks';
import { VideoItemThumbnail } from 'components/video-generating';

export const VideoItem = ({
  url,
  video,
  className,
  pageNumber,
  sort,
  maskJSX,
  contextMenu,
  width,
  showRating,
  thumbnailRef,
  'data-e2e': dataE2e,
}) => (
  <figure role="group" data-e2e={dataE2e} className={`ct-video-item ${className || ''}`} style={{ width }}>
    {/* thumbnail */}
    <div ref={thumbnailRef}>
      <VideoItemThumbnail url={url + '#top'} video={video}>
        {maskJSX && maskJSX({ video })}
        <DurationMask duration={video.length} />
      </VideoItemThumbnail>
    </div>

    <figcaption>
      <div className="ct-video-item__info">
        <Link className="ct-video-item__title" to={url + '#top'}>
          {video.title}
        </Link>
        <div className="ct-video-item__context-menu" data-e2e="videoItemContextMenu">
          {contextMenu &&
            contextMenu({ video, pageNumber, sort, isItem: true, className: 'ct-video-list__context-menu' })}
        </div>
      </div>

      <VideoItemAdditionalMetadata video={video} showRating={showRating} />
    </figcaption>
  </figure>
);

VideoItem.propTypes = {
  url: PropTypes.string.isRequired,
  video: PropTypes.object.isRequired,
  className: PropTypes.string,
  maskJSX: PropTypes.func,
  contextMenu: PropTypes.func,
  pageNumber: PropTypes.number,
  sort: PropTypes.string,
  showRating: PropTypes.bool,
};
